import React from 'react'
import { keyframes, css } from 'styled-components'
import { Box } from 'rebass'
import PropTypes from 'prop-types'

const downOut = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  80% {
    transform: translateY(0);
    opacity: 0;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
`

export const LoadingOverlay = ({ fadeOut }) => (
  <Box
    css={css`
      background-image: linear-gradient(to top, #ffffff 80%, rgba(255, 255, 255, 0));
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      content: '';
      z-index: 111;
      ${fadeOut &&
        css`
          animation: ${downOut} 1s;
          animation-timing-function: ease-in-out;
          animation-fill-mode: forwards;
        `}
    `}
  />
)
LoadingOverlay.propTypes = {
  fadeOut: PropTypes.bool.isRequired,
}
